import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('sitiClienti');
export const actions = helper.createActions('sitiClienti', actionTypes);